import { ActionButton } from '@eastcoal/common/components/Button/ActionButton'
import { pick } from '@eastcoal/common/utils/object'

import { FormMode } from '@eastcoal/formily/components/CrudForm/enums/FormMode'

import { MEMBER_MANAGE_ACTION_UUID } from '../../../../../constants/uuid'
import { useMemberBankListStore } from '../../../Store/hooks/useStore'

import { MemberBankEditButtonProps } from './interface'

export const MemberBankEditButton = ({ record }: MemberBankEditButtonProps) => {
  const { setCurrentAccountId, setFormMode, toggleAccountFormVisible } =
    useMemberBankListStore(state =>
      pick(state, [
        'setCurrentAccountId',
        'setFormMode',
        'toggleAccountFormVisible'
      ])
    )

  const handleClick = () => {
    setFormMode(FormMode.UPDATE)
    setCurrentAccountId(record.id)
    toggleAccountFormVisible()
  }

  return (
    <ActionButton
      type='link'
      uuid={MEMBER_MANAGE_ACTION_UUID}
      onClick={handleClick}
    >
      编辑
    </ActionButton>
  )
}
